import getApiBaseUrl from "../../utils/api";

const API_URL = getApiBaseUrl();

const dashboardActions = ({ getStore, getActions, setStore }) => ({
  getDashboard: async () => {
    try {
      const { token } = getStore();

      const response = await fetch(`${API_URL}/api/kpis/dashboard`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const error = await getActions().handleApiError(response);
      if (error) return null;

      const data = await response.json();

      setStore({
        dashboard: data,
      });

      return data;
    } catch (error) {
      console.error("Dashboard error:", error);
      getActions().showToast("Error cargando dashboard", "error");
      return null;
    }
  },
});

export default dashboardActions;
